import React, { useState } from 'react';
import { Collapse } from 'reactstrap';

function ViewMyPersonalInfo(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    return (
        <div className="mg-t-20" >
        <div className="card" >
            <div className="card-header">
                <div className="card-header-left">
                    <h5>Personal Information</h5>
                </div>
                <div className="card-header-right">
                    <ul className="row" >                        
                        
                        <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                        
                    </ul>                    
                </div>                
            </div> 
            <Collapse isOpen={!collapse}>            
            <hr className="mg-l-20" ></hr>
            <div className="card-block">
                 <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Gender</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15">Female</div>                    
                    </div>
                </div> 
                  
                <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Languages Known</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15">English, Hindi, Bengali</div>                    
                    </div>
                </div> 
                <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Passport #</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15">JDDOWJ2647</div>                    
                    </div>
                </div>   
                <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Visa Status</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15">B1/B2 USA (Jun 06, 2025)</div>
                    </div>
                </div>   
                <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Marital Status</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15">Married</div>                    
                    </div>
                </div> 
            </div>
            </Collapse>
    </div>
    </div>
        
    );
  }

export default ViewMyPersonalInfo